// Stub for findMatchingProductVariant
export function findMatchingProductVariant(options) {
    // Basic stub - returns first variant or null
    return options?.variants?.[0] || null;
}

// Export alias for compatibility
export const findMatchingVariant = findMatchingProductVariant;
